import React, { useState } from "react";
import Webcam from "react-webcam";
import { readPhoneScan } from "../../utilities";
import Tesseract from "tesseract.js";
import { Box, CircularProgress, Typography } from "@mui/material";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import { PageHeader, PageShell } from "../../components/UI/Page";

const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: "user",
};

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress size={64} variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          className="app-muted tabular-nums"
        >
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

const ManagePhone = () => {
  const [image, setImage] = useState(null);
  const [uploadResults, setUploadResults] = useState(null);
  const [progress, setProgress] = useState(0);

  const handleUpload = async () => {
    if (image) {
      Tesseract.recognize(image, "eng", {
        logger: (m) => {
          setProgress(m.progress * 100);
        },
      }).then(({ data: { text } }) => {
        setUploadResults(text);
      });
    }
  };

  return (
    <PageShell size="sm">
      <PageHeader
        icon={PhoneIphoneIcon}
        tone="slate"
        eyebrow="Admin"
        title="Phone Management Tool"
        description="Capture a photo with the camera, then submit it to read the text in it."
      />

      <div className="app-card rounded-2xl border p-4 sm:p-5">
        {!image && (
          <Webcam
            className="block h-auto w-full rounded-xl bg-black"
            audio={false}
            screenshotFormat="image/jpeg"
            width={500}
            videoConstraints={videoConstraints}
          >
            {({ getScreenshot }) => (
              <div className="mt-4 flex justify-center">
                <button
                  type="button"
                  className="app-btn app-btn-primary app-btn-lg"
                  onClick={() => {
                    const imageSrc = getScreenshot();

                    setImage(imageSrc);
                  }}
                >
                  <PhotoCameraIcon sx={{ fontSize: 20 }} />
                  Capture photo
                </button>
              </div>
            )}
          </Webcam>
        )}

        {image && (
          <div className="flex flex-col items-center gap-4">
            <img
              className="block h-auto w-full rounded-xl"
              src={image}
              alt="Captured phone"
            />
            <div className="flex flex-wrap justify-center gap-2">
              <button
                type="button"
                className="app-btn app-btn-secondary"
                onClick={() => {
                  setImage(null);
                }}
              >
                RETAKE
              </button>
              <button
                type="button"
                className="app-btn app-btn-primary"
                onClick={() => {
                  handleUpload();
                }}
              >
                SUBMIT
              </button>
            </div>
            {progress > 1 && <CircularProgressWithLabel value={progress} />}
          </div>
        )}

        {uploadResults && (
          <div className="app-surface mt-4 whitespace-pre-wrap break-words rounded-xl border p-4 font-mono text-sm">
            {uploadResults}
          </div>
        )}
      </div>
    </PageShell>
  );
};

export default ManagePhone;
